import React from "react";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer } from "../../../components/grid-container/GridContainer";
import HistoricGoalCard from "./HistoricGoalCard";

export const HistoricGoals = (props) => {
    return (
        <>

            <UiContentWr>
                <UiRowContainer fluid="fluid" className="sb-historic-goals-sec">
                    <UiCol lg="12">
                        <UiCardTitle title="Historic Goals" />
                    </UiCol>
                    <UiCol lg="12">
                        <HistoricGoalCard />
                        <HistoricGoalCard />
                        <HistoricGoalCard />
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>

        </>
    )
}